// LayoutEditorToolbarAction.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Components
import Button from 'components/button/Button';
import IconButton from 'components/iconbutton/IconButton';

/**
 * LayoutEditorToolbarAction
 *
 * @returns {ReactNode} The rendered component.
 */
const LayoutEditorToolbarAction = ({
    action = null,
    actionKey = '',
    addon = 'icon',
}) => {

    // ----- CONTEXT ----- //

    const { theme } = useTheme();

    const resolvedActionKey = String(actionKey || action?.title || action?.label || action?.iconKey || 'toolbar-action').trim();
    const resolvedAddon = addon === 'pill' ? 'pill' : 'icon';

    if (typeof action?.onClick !== 'function') return null;

    if (resolvedAddon === 'icon') {
        if (!action?.iconKey) return null;
        return (
            <IconButton
              key={resolvedActionKey}
              iconKey={action.iconKey}
              iconSize={18}
              size={30}
              title={action.title}
              onClick={action.onClick}
            />
        );
    }

    if (!action?.label && action?.iconKey) {
        return (
            <IconButton
              key={resolvedActionKey}
              iconKey={action.iconKey}
              iconSize={18}
              size={30}
              title={action.title}
              onClick={action.onClick}
            />
        );
    }

    if (!action?.label) return null;

    const resolvedIconKey = Object.prototype.hasOwnProperty.call(action, 'iconKey')
        ? action.iconKey
        : 'add';

    // ----- RENDER ----- //

    return (
        <Button
          key={resolvedActionKey}
          backgroundColor={theme.buttonBackgroundColor}
          borderColor={theme.backgroundHover}
          borderRadius={999}
          fontSize="12px"
          foregroundColor={theme.foreground}
          height="30px"
          iconKey={resolvedIconKey || undefined}
          label={action.label}
          padding="0 12px"
          title={action.title}
          onClick={action.onClick}
        />
    );
};

// Dev Tools
LayoutEditorToolbarAction.displayName = 'LayoutEditorToolbarAction';

export default LayoutEditorToolbarAction;
